import { post, get } from '@/utils/api';

type DownloadFile = {
  downloadUrl: string;
};

const fetchUrl = async (fileId: string, fileTeamId: string) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { fileUrl: fileURL }: { fileUrl: string } = await get(
    `file/${fileId}/${fileTeamId}`
  );
  return fileURL;
};

const processDownloadUrl = async (url: string, fileName: string) => {
  const data = (await post('files/download', {
    url,
    fileName,
  })) as DownloadFile;

  if (data.downloadUrl) {
    window.open(data.downloadUrl, '_blank');
  } else {
    throw new Error('Download URL not found');
  }
};

export { fetchUrl, processDownloadUrl };
